// ABOUTME: Modal for editing existing behavior records (type and notes)
// ABOUTME: Allows admin to correct behavior entries or add context

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { BehaviorEventEntry } from '../../BehaviorEventsTable';
import { BehaviorType } from '../../../types/api';
import { getBehaviorIcon, getBehaviorLabel } from '../../../utils/behaviorUtils';

interface EditBehaviorModalProps {
  open: boolean;
  behavior: BehaviorEventEntry | null;
  onClose: () => void;
  onChange: (behavior: BehaviorEventEntry) => void;
  onSubmit: () => Promise<void>;
}

const EditBehaviorModal: React.FC<EditBehaviorModalProps> = ({
  open,
  behavior,
  onClose,
  onChange,
  onSubmit
}) => {
  if (!behavior) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Behavior Record</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <Typography variant="body2" color="text.secondary">
            Child: {behavior.childName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Date: {new Date(behavior.recordedAt).toLocaleString()}
          </Typography>
          <FormControl fullWidth>
            <InputLabel>Behavior Type</InputLabel>
            <Select
              value={behavior.behaviorType}
              label="Behavior Type"
              onChange={(e) => onChange({
                ...behavior,
                behaviorType: e.target.value as BehaviorType
              })}
            >
              {Object.values(BehaviorType)
                .filter((v): v is BehaviorType => typeof v === 'number')
                .map((type) => (
                  <MenuItem key={type} value={type}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {/* Icon glyph sizing via fontSize, not a Typography text override */}
                      {getBehaviorIcon(type, { sx: { fontSize: 16, mr: 1 } })}
                      {getBehaviorLabel(type)}
                    </Box>
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <TextField
            label="Notes"
            value={behavior.notes || ''}
            onChange={(e) => onChange({
              ...behavior,
              notes: e.target.value
            })}
            fullWidth
            multiline
            rows={3}
            placeholder="Add notes about this behavior..."
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSubmit} variant="contained">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditBehaviorModal;
